export default "__VITE_ASSET__CDXlk7RG__"